<!-- 组件说明 -->
<template>
  <div class="sign">
    签约：{{ moment(followItem.signDate).format("YYYY/MM/DD") }}
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    followItem: {
      type: Object,
    },
  },
  data() {
    return {
      moment,
    };
  },
};
</script>

<style lang="scss" scoped>
.sign {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
</style>
